import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Add as AddIcon, Grass as GrassIcon, Home as IndoorIcon, Sports as SportsIcon, } from "@mui/icons-material";
import { Avatar, Box, Card, CardContent, Chip, Divider, IconButton, Stack, Typography, } from "@mui/material";
import { useNavigate } from "react-router-dom";
const SURFACE_DISPLAY = {
    grass: "Grass",
    artificial_turf: "Artificial Turf",
    astroturf: "Astroturf",
    indoor: "Indoor",
    hybrid: "Hybrid",
};
const getSurfaceIcon = (surface) => {
    switch (surface) {
        case "grass":
        case "artificial_turf":
        case "astroturf":
        case "hybrid":
            return _jsx(GrassIcon, { fontSize: "small" });
        case "indoor":
            return _jsx(IndoorIcon, { fontSize: "small" });
        default:
            return _jsx(SportsIcon, { fontSize: "small" });
    }
};
const PitchItem = ({ pitch, isLast }) => {
    return (_jsxs(Box, { sx: {
            p: 2.5,
            display: "flex",
            alignItems: "center",
            borderBottom: isLast ? "none" : "1px solid rgba(0,0,0,0.08)",
        }, children: [_jsx(Avatar, { sx: {
                    width: 40,
                    height: 40,
                    backgroundColor: "rgba(76, 175, 80, 0.1)",
                    color: "success.main",
                }, children: getSurfaceIcon(pitch.surface) }), _jsxs(Box, { sx: { ml: 2, flexGrow: 1 }, children: [_jsx(Typography, { variant: "body1", sx: { fontWeight: 600, mb: 0.5 }, children: pitch.name }), _jsxs(Stack, { direction: "row", spacing: 1, sx: { flexWrap: "wrap", gap: 1 }, children: [pitch.sizes.map((size) => (_jsx(Chip, { size: "small", label: `${size}-a-side`, sx: { fontSize: "0.75rem" } }, size))), _jsx(Chip, { size: "small", label: SURFACE_DISPLAY[pitch.surface] || pitch.surface, sx: { fontSize: "0.75rem" } }), pitch.isIndoor && (_jsx(Chip, { size: "small", label: "Indoor", sx: { fontSize: "0.75rem" } }))] })] })] }));
};
const PitchList = ({ venueId, pitches }) => {
    const navigate = useNavigate();
    const handleAddPitch = () => {
        navigate(`/venues/${venueId}/pitches/create`);
    };
    return (_jsx(Card, { children: _jsxs(CardContent, { children: [_jsxs(Box, { sx: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        mb: 2,
                    }, children: [_jsxs(Box, { sx: { display: "flex", alignItems: "center", gap: 1 }, children: [_jsx(Typography, { variant: "h6", sx: { fontWeight: 600 }, children: "Pitches" }), pitches && pitches.length > 0 && (_jsx(Chip, { label: pitches.length, size: "small", sx: {
                                        backgroundColor: "rgba(76, 175, 80, 0.1)",
                                        color: "success.main",
                                        fontWeight: 600,
                                        minWidth: 24,
                                    } }))] }), _jsx(IconButton, { onClick: handleAddPitch, size: "small", title: "Add pitch", sx: {
                                color: "success.main",
                                "&:hover": {
                                    backgroundColor: "rgba(76, 175, 80, 0.1)",
                                    transform: "scale(1.05)",
                                },
                                transition: "all 0.2s ease",
                            }, children: _jsx(AddIcon, {}) })] }), _jsx(Divider, { sx: { mb: 2 } }), _jsx(Stack, { spacing: 0, children: pitches && pitches.length > 0 ? (pitches.map((pitch, index) => (_jsx(PitchItem, { pitch: pitch, isLast: index === pitches.length - 1 }, pitch.id)))) : (_jsxs(Box, { sx: { p: 4, textAlign: "center" }, children: [_jsx(Avatar, { sx: {
                                    width: 56,
                                    height: 56,
                                    backgroundColor: "rgba(76, 175, 80, 0.1)",
                                    color: "success.main",
                                    mx: "auto",
                                    mb: 2,
                                }, children: _jsx(SportsIcon, { sx: { fontSize: 28 } }) }), _jsx(Typography, { variant: "h6", color: "text.secondary", sx: { mb: 1 }, children: "No pitches yet" }), _jsx(Typography, { variant: "body2", color: "text.secondary", sx: { mb: 2 }, children: "Help others by adding the pitch configurations at this venue" }), _jsx(IconButton, { onClick: handleAddPitch, sx: {
                                    backgroundColor: "success.main",
                                    color: "white",
                                    "&:hover": {
                                        backgroundColor: "success.dark",
                                        transform: "scale(1.05)",
                                    },
                                    transition: "all 0.2s ease",
                                }, children: _jsx(AddIcon, {}) })] })) })] }) }));
};
export default PitchList;
